<template>
  <h3>works</h3>
  <div class="works-list">
    <div v-for="result in processedResults" :key="result.id">
      <a :href="result.post_url">
        <p>{{ result.title }}</p>
        <img :src="result.image" width="100px" />
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "WorksList",
  data() {
    return {
      info: null,
      results: [],
    };
  },
  // (f)
  mounted: function () {},
  computed: {
    processedResults: function () {
      let results = this.results;
      results = [
        {
          id: 1,
          title: "メモリアミュージック",
          post_url:
            "https://play.google.com/store/apps/details?id=jp.studiojambo.MemoriaMusic",
          image: require("@/assets/games/thumb/1.png"),
        },
       /* {
          id: 2,
          title: "メモリアミュージックプラス",
          post_url:
            "https://play.google.com/store/apps/details?id=jp.studiojambo.MemoriaMusicPlus",
          image: require("@/assets/games/thumb/2.png"),
        },*/
      ];
      return results;
    },
  },
};
</script>
<style lang="css">
.works-list {
  display: grid;
  grid-template-columns: auto auto;
  justify-content: center; /* グリッド全体を中央 */
}
</style>
